/* To make this work, you have to extend this class to
   1) define a listener that processes your specific form in attachedCallback()
   2) define a $closeModal function with your form's modal id
   There is probably a better way to do this...
 */


u.ModalForm = class extends u.BaseForm {

    attachedCallback(){
        super.attachedCallback();
        document.addEventListener('sb-captcha-success', function (event) {
            this.elements.submitbtn.classList.remove('u.btn:blue');
            this.elements.submitbtn.classList.add('u.btn:green');
            this.recaptchaResponse = event.detail.response;
        }.bind(this));

        this.message = this.querySelector('.error');
        this.close = false;
        this.$clearMsg();

        this.addEventListener('submit', (event) => {
            event.preventDefault();

            if (!this.checkValidity()) {
                return;
            }
            
            // if the form was already submitted then handle close
            if (this.close) {
                this.$closeModal();
                return;
            }

            // if recaptcha is not done, abort
            if (this.elements['g-recaptcha-response'].value!==this.recaptchaResponse) {
                window.grecaptcha.reset();
                this.$error('Please prove that you are not a robot.');
                return;
            }

            this.$clearMsg();
            this.$submit(event);
        });

        this.addEventListener('click', this._click);
    }

    $submit(event) {
        // extend me
    }

    $onSuccess() {
        this.$success("Thank you for your feedback.");
        this.elements.submitbtn.value = "Close";
        this.close = true;

        for(let element of this.elements) {
            if(element !== this.elements.submitbtn) {
                element.disabled = true;
            }
        }
    }

    $closeModal() {
        window.location.reload(false);
    }

    $error(message) {
        this.$clearMsg();
        this.message.classList.add('sb.color:red');
        this.message.textContent = message;
    }

    $clearMsg() {
        this.message.classList.remove('sb.color:red');
        this.message.textContent = '';
    }

    $success(message) {
        this.$clearMsg();
        this.message.textContent = message;
    }
}

u.ModalForm.register('u-modal-form');